import "$styles/index.css"

import { Application } from "@hotwired/stimulus"
import { Modal } from "tailwindcss-stimulus-components"
import LiteYoutubeController from "./controllers/lite_youtube_controller.js"
import AccordionController from "./controllers/accordion_controller.js"
import PricingCalculatorController from "./controllers/pricing_calculator_controller.js"
import PricingLeadCalculatorV2Controller from "./controllers/pricing_lead_calculator_v2_controller.js"

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

const application = Application.start()
application.register("lite-youtube", LiteYoutubeController)
application.register("accordion", AccordionController)
application.register("modal", Modal)
application.register("pricing-calculator", PricingCalculatorController)
application.register("pricing-lead-calculator-v2", PricingLeadCalculatorV2Controller)
